import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getSectorContactPersons = (user, { sector }) => {
  return requestWithPromise(
    `/api/sectors/${getIdOrNull(sector)}/contact-persons`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getSectionContactPersons = (user, { section }) => {
  return requestWithPromise(
    `/api/school-sections/${getIdOrNull(section)}/contact-persons`,
    HttpMethods.GET,
    null,
    user
  )
}
